export default {"src":"/_next/static/media/contentstack.a4069421.svg","height":79,"width":452,"blurWidth":0,"blurHeight":0};